<template>
  <RemotePaginatedList :hide-search="hideSearch"
                       :filter-options="filterOptions"
                       :headers="headers"
                       multi-sort
                       :show-select="showSelect"
                       v-model="selectedItemIds"
                       data-url="aafb/admin/coupon/"
                       data-key="coupons"
                       :extra-params="{user_id: userId}"
                       :refresh-trigger.sync="innerRefreshTrigger"
                       v-bind="$attrs">
    <template v-slot:item.create_at="{value}">
      {{ $parseDate(value) }}
    </template>
    <template v-slot:item.valid_until="{value}">
      {{ $parseDate(value, 'yyyy-MM-dd') }}
    </template>
    <template #item.type="{item, value}">
      {{ $t(`admin_acc_discount_code.type_${value}`) }}
      {{ item.type !== 'MEMBERSHIP' ? ' - ' : '' }}
      {{ item.type === 'FACILITY' ? item.item_type.name : '' }}
      {{ item.type === 'GYM_PASS' ? item.gym_pass_type.name : '' }}
    </template>
    <template v-slot:item.redeemed_at="{value}">
      {{ value ? $parseDate(value) : '' }}
    </template>
    <template v-slot:item.used_at="{value}">
      {{ value ? $parseDate(value) : '' }}
    </template>
  </RemotePaginatedList>
</template>

<script>
import {computed, onMounted, ref, watch} from '@vue/composition-api'
import RemotePaginatedList from "@/components/RemotePaginatedList";
import _ from "lodash";

export default {
  name: 'AdminCouponList',
  components: {RemotePaginatedList},
  props: {
    value: Array,
    hideSearch: Boolean,
    showSelect: Boolean,
    refreshTrigger: Boolean,
    userId: String,
  },
  setup(props, {root, emit}) {
    const refresh = function () {
      innerRefreshTrigger.value = true;
    };
    onMounted(() => {
      refresh();
    });

    watch(() => props.refreshTrigger, (newValue) => {
      if (newValue) {
        refresh();
        emit('update:refresh-trigger', false);
      }
    })

    // Filter
    const filterOptions = computed(() => {
      return [
        // {text: root.$t('admin_event.name_en'), value: 'base_event.name_en', contains: true},
        // {text: root.$t('admin_event.name_zh'), value: 'base_event.name_zh', contains: true},
        {
          text: root.$t('admin_acc_coupon.type'), value: 'type',
          options: [
            {text: root.$t('admin_acc_coupon.type_FACILITY'), value: 'FACILITY'},
            {text: root.$t('admin_acc_coupon.type_GYM_PASS'), value: 'GYM_PASS'},
            {text: root.$t('admin_acc_coupon.type_MEMBERSHIP'), value: 'MEMBERSHIP'},
          ],
        },
        {
          text: root.$t('admin_acc_coupon.redeemed'), value: 'account',
          options: [
            {text: root.$t('yes'), value: true},
            {text: root.$t('no'), value: false},
          ], single: true,
        },
        {text: root.$t('admin_user.serial_no'), value: 'account.hkiarace_account.id', exact: true},
        {text: root.$t('admin_acc_coupon.redeem_code'), value: 'redeem_code', exact: true},
      ]
    })

    // Data Table
    const headers = ref([
      {text: root.$t('coupon.create_at'), value: 'create_at'},
      {text: root.$t('coupon.valid_until'), value: 'valid_until'},
      {text: root.$t('admin_acc_coupon.type'), value: 'type', sortable: false},
      {text: root.$t('admin_acc_coupon.amount'), value: 'amount'},
      {text: root.$t('admin_user.serial_no'), value: 'account.hkiarace_no', sortable: false},
      {text: root.$t('admin_acc_coupon.redeem_code'), value: 'redeem_code'},
      {text: root.$t('admin_acc_coupon.redeemed_at'), value: 'redeemed_at'},
      {text: root.$t('coupon.used_at'), value: 'used_at'},
    ]);
    const innerRefreshTrigger = ref(false);

    const selectedItemIds = ref([]);
    watch(() => selectedItemIds.value, (newValue) => {
      emit('input', newValue);
    });

    watch(() => props.value, (newValue, oldValue) => {
      if (_.xor(newValue, oldValue).length) {
        selectedItemIds.value = newValue;
      }
    }, {deep: true, immediate: true})

    const getCouponType = function (coupon) {
      if (coupon.item_type) return coupon.item_type.name;
      if (coupon.gym_pass_type) return `${root.$t('gym_subscription.title')} - ${coupon.gym_pass_type.name}`;
    }

    const getCouponUsedOn = function (coupon) {
      if (coupon.used_on_booking) return `${root.$parseDate(coupon.used_on_booking.start_time, 'yyyy-MM-dd HH:mm')} - ${root.$parseDate(coupon.used_on_booking.end_time, 'HH:mm')} ${coupon.used_on_booking.item.name}`;
      if (coupon.used_on_gym_subscription) return `${root.$parseDate(coupon.used_on_gym_subscription.create_at, 'yyyy-MM-dd HH:mm')} - ${"GYM" + coupon.used_on_gym_subscription.reference_number.toString().padStart(8, '0')}`;
    }


    return {
      filterOptions,

      headers,
      innerRefreshTrigger,
      selectedItemIds,

      getCouponType,
      getCouponUsedOn,
    }
  }
}
</script>
